import { Box, Grid, Typography, useTheme } from '@mui/material';
import Image from 'next/image';
import DoctorIllustration from '../../public/DoctorIllustration.png';
import ProductShot from '../../public/MobileScreenshot.png';
import { EngagementEvents, logKariusEvent } from '../Analytics';
import IconAppleStore from '../assets/images/svg/IconAppleStore';
import IconGoogleStore from '../assets/images/svg/IconGoogleStore';

export const MobileMarketing = () => {
  const theme = useTheme();

  return (
    <Grid
      container
      sx={{
        width: {
          md: '399px',
        },
        gap: theme.spacing(2),
      }}
      flexDirection='column'
      id='mobileMarketing'
    >
      <Box sx={{ width: '100%', display: { xs: 'none', md: 'block' } }}>
        <Image
          layout='responsive'
          src={ProductShot}
          quality={100}
          alt='Karius App'
          placeholder='blur'
          data-test='app-image'
        />
      </Box>
      <Grid container justifyContent='center'>
        <Grid container maxWidth='500px' alignItems='center' sx={{ display: { xs: 'flex', md: 'none' } }}>
          <Grid item xs={4} sx={{ width: '127px', paddingRight: '11px' }}>
            <Image layout='responsive' src={DoctorIllustration} alt='Doctor' />
          </Grid>
          <Grid item xs={8}>
            <PromoText />
          </Grid>
        </Grid>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <PromoText />
        </Box>
      </Grid>
      <Grid
        justifyContent='center'
        flexDirection='row'
        container
        sx={{
          '& .download-btn': {
            height: '40px',
          },
          gap: '12px',
        }}
      >
        <Grid item>
          <a
            href='https://apps.apple.com/app/apple-store/id1524044861?pt=120542634&ct=online_portal_login&mt=8'
            onClick={() => logMobileTap('ios')}
          >
            <IconAppleStore className='download-btn' />
          </a>
        </Grid>
        <Grid item>
          <a
            href='https://play.google.com/store/apps/details?id=com.kariusdx.mobile&referrer=utm_source%3Donline_portal_login%26utm_medium%3Dplay_store_button'
            onClick={() => logMobileTap('android')}
          >
            <IconGoogleStore className='download-btn' />
          </a>
        </Grid>
      </Grid>
    </Grid>
  );
};

const PromoText = () => {
  return (
    <Grid
      container
      flexDirection='column'
      sx={{
        maxWidth: {
          md: '360px',
        },
        gap: {
          md: '8px',
          xs: '6px',
        },
        '& .promo-text': {
          textAlign: {
            md: 'center',
            xs: 'left',
          },
        },
      }}
    >
      <Typography variant='heading_03' className='promo-text'>
        Get the Karius App
      </Typography>
      <Typography variant='body_01' className='promo-text'>
        The most convenient way to get realtime updates on order status and view results. The Karius App does not yet
        support ordering tests.
      </Typography>
    </Grid>
  );
};

const logMobileTap = (os: 'android' | 'ios') => logKariusEvent(EngagementEvents.mobile_app_download_tapped, { os });
